__turbopack_context__.v({
  "backBtn": "_6cIBoq_backBtn",
  "gridList": "_6cIBoq_gridList",
  "linkCard": "_6cIBoq_linkCard",
  "result": "_6cIBoq_result",
});
